import React from 'react'
import Text from '../../atoms/Text'
import LockedGoals from '../../../assets/images/locked-goals.webp'
import Button from '../../atoms/GoodFlipButton'

const UnlockKidneyScore = ({ onClick = () => {} }) => {
  return (
    <div className="flex flex-col gap-4 bg-background-accent-gold py-10 px-4 lg:flex-row lg:items-center lg:gap-10 lg:px-8 lg:py-12 lg:rounded-2xl">
      <div className="flex flex-col gap-2 lg:flex-1">
        <div className="w-fit bg-gradient-to-r from-GOLD-900 via-GOLD-800 to-GOLD-900 py-1 px-1.5 rounded-2">
          <Text
            tag={'p'}
            variant={'label'}
            size={'small'}
            className={'text-text-primary-on-brand'}
          >
            Just 1 Step Away
          </Text>
        </div>
        <Text
          tag={'p'}
          variant={'headline'}
          size={'large'}
          className={'text-text-primary'}
        >
          Unlock Your Kidney Profile Score
        </Text>
        <Text
          tag={'p'}
          variant={'body'}
          size={'medium'}
          className={'text-text-quartenary'}
        >
          Crafted to give you deeper insights into your kidney health, the
          Kidney Profile Score analyses your lifestyle and symptoms to provide a
          personalised assessment.
        </Text>
        <div className="hidden lg:block lg:mt-2">
          <Button
            title={'Unlock Kidney Profile Score'}
            className="!mx-0 lg:!max-w-xs"
            type={'goodflip_primary'}
            onClick={onClick}
            leftIcon={null}
            rightIcon={null}
          />
        </div>
      </div>
      <div className="lg:flex-1 lg:max-w-sm">
        <img src={LockedGoals} alt="locked-goals" className="w-full h-auto" />
      </div>
      <div className="lg:hidden">
        <Button
          title={'Unlock Kidney Profile Score'}
          className="!mx-0"
          type={'goodflip_primary'}
          onClick={onClick}
          leftIcon={null}
          rightIcon={null}
        />
      </div>
    </div>
  )
}

export default UnlockKidneyScore
